"use strict";

if (!Object.assign) {
	Object.assign = require("object-assign");
}

// These are the bulk of the components used on the constituent side, made available as asoComponents.js
var exports = Object.assign({},
	require("./analytics/StudioOnlineAnalytics"),
	require("./commonComponents/expose"),
	require("./checkoutComponents/ExposedCheckoutComponents"),
	require("./contactUsComponents/expose"),
	require("./searchComponents/expose"),
	require("./accountComponents/expose"));

module.exports = exports;
